import { toast } from "react-toastify";
import { BASE_URL } from "./connectionUrl";

export const postReply = async (token, id, payload) => {
    try {
        const response = await fetch(
            `${BASE_URL}/api/v1/queries/${id}/query_replies`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Token ${token}`,
                },
                body: JSON.stringify(payload),
            }
        );

        const data = await response.json();
        if (data.status.status === "SUCCESS") {
            return data;
        } else {
            toast.error(data?.status?.message || "something went wrong");
        }
    } catch (error) {
        toast.error(error.message || "something went wrong");
    }
};
